import React, {
  useRef,
  useImperativeHandle,
  useCallback,
  useMemo,
  useState,
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import { isEmpty, isArray, merge } from 'lodash';

import { Modal, Tabs, Spinner } from '~/components';
import api from '~/services/api';

import { GFE, GFO, GFU, GPP, GPPEM, GFU_CONSULTA } from '~/constants/perfil';

import { differenceBy, concat, get, assign } from 'lodash';

import { t, validCharacters, validSomenteNumeros, validCharactersParaSenha, validarCPF } from '~/helpers';

import qs from 'querystring';

import * as Yup from 'yup';

//import { updateUnidade } from '~/store/modules/unidade/actions';

import { DadosUsuario, DadosPosto, DadosUnidade } from '../Tabs';

import { ADM } from '~/constants/perfil';

import usuarioMasterVO from './usuarioCrud';

import { storeCadastroUsuarioMaster, updateCadastroUsuarioMaster, cleanErrors } from '~/store/modules/cadastrousuariomaster/actions';
import { ContactSupportOutlined } from '@material-ui/icons';
import { CircularProgress, Typography } from '@material-ui/core'

const Form = React.forwardRef(({ formEdit, onCloseModal }, ref) => {
  const dispatch = useDispatch();

  const { params } = useSelector(
    (state) => state.cadastrousuariomaster
  );

  const redux = useSelector((state) => state.cadastrousuariomaster)


  const { profile } = useSelector((state) => state.user);

  const [data, setData] = useState({});


  // const [dataUsuario, setDataUsuario] = useState({});
  // const [dataUnidades, setDataUnidades] = useState({});
  // const [dataPostos, setDataPostos] = useState({});
  const [selectedPerf_tipo, setSelectedPerf_tipo] = useState('')

  const [loading, setLoading] = useState(false);
  const [onSubmitting, setOnSubmitting] = useState(false)
  const [submittingLoading, setSubmittingLoading] = useState(false)

  const [habTabUnidades, setHabTabUnidades] = useState(false);
  const [habTabPostos, setHabTabPostos] = useState(false);

  const modalRef = useRef(null);
  const tabRef = useRef(null);
  const formRef = useRef(ref);


  useEffect(() => {
    if (onSubmitting && !redux.loading && !redux.hasError) {
      closeModal();
      setOnSubmitting(false);
      setLoading(false);
      setSubmittingLoading(false)

    } else if (redux.hasError) {
      setOnSubmitting(false);
      setLoading(false);
      setSubmittingLoading(false)
    }
  }, [redux, onSubmitting])





  const openModal = useCallback(() => {
    modalRef.current.handleOpenModal();

    if (!isEmpty(formEdit)) {
      handleResponseEditarAPI();
    } else {
      handleResponseIncluirAPI();
    }

  }, [formEdit]);

  useImperativeHandle(ref, () => ({
    openModal,
  }));



  const onHandleAtualizaPerfCodigo = useCallback(async (perf_codigo) => {

    const objSend = {
      ...data,
      perf_codigo: perf_codigo,

    };
    setData(objSend);

  }, [data]);


  // const onHandleBuscaUnidadeOrgao = useCallback(async (orga_codigo) => {

  //   try {
  //     setLoading(true);

  //     //Busca Unidade geral
  //     let params = {};
  //     switch (profile.glousuariotipo) {
  //       case GFO:
  //         params = {
  //           fieldlist: 'unid_nome, unid_codigo ',
  //           wherefield: ['orga_codigo'],
  //           typewherefield: ['EQUALS'],
  //           valuewherefield: [profile.glousuarioorgacodigo],
  //           orderfield: 'unid_codigo',
  //           pagesize: 99999,
  //         }
  //         break;
  //       default:
  //         params = {
  //           fieldlist: 'unid_nome, unid_codigo, orga_codigo ',
  //           wherefield: ['orga_codigo'],
  //           typewherefield: ['EQUALS'],
  //           valuewherefield: [orga_codigo],
  //           orderfield: 'unid_codigo',
  //           pagesize: 99999,
  //         }
  //     }
  //     const responseUnidades = await api.get('unidades', {
  //       params,
  //       paramsSerializer: (param) => qs.stringify(param),
  //     });
  //     let dadosUnidades = responseUnidades.data.items;

  //     const objSend = {
  //       ...data,
  //       orga_codigo: orga_codigo,
  //       //dadosUnidades: dadosUnidades,
  //       rowsDisponiveis: dadosUnidades,
  //       rowsSelecionadas: [],
  //     };
  //     setData(objSend);

  //   } catch (err) {
  //     if (isArray(err)) err.map((e) => toast.error(t(e)));
  //     else toast.error(t(err));
  //   } finally {
  //     setLoading(false);
  //   }

  // }, [data]);


  const onHandleBuscaPostosGPPEM = useCallback(async () => {
    try {
      setLoading(true);
      let params = {};
      params = {
        fieldlist: 'poco_desc_abrev, poco_codigo',
        orderfield: 'poco_desc_abrev',
        pagesize: 99999,
      }
      const responsePostos = await api.get('postoscomboios', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });
      let dadosPostos = responsePostos.data.items;
      let dataSend = {
        ...data,
        dadosPostos: dadosPostos,
        rowsDisponiveis: dadosPostos,
        rowsSelecionadas: [],
      }
      setData(dataSend);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [data]);


  //Busca dados do usuario para editar o registro
  const handleResponseIncluirAPI = useCallback(async () => {
    try {
      setLoading(true);

      let dadosUsuario = { ...usuarioMasterVO };

      //Busca Unidade geral

      let dadosUnidades = [];
      if (profile.glousuariotipo === GFO) {

        setHabTabUnidades(true);

        let params = {};

        params = {
          fieldlist: 'unid_nome, unid_codigo ',
          wherefield: ['orga_codigo'],
          typewherefield: ['EQUALS'],
          valuewherefield: [profile.glousuarioorgacodigo],
          orderfield: 'unid_codigo',
          pagesize: 99999,
        }

        const responseUnidades = await api.get('unidades', {
          params,
          paramsSerializer: (param) => qs.stringify(param),
        });
        dadosUnidades = responseUnidades.data.items;
      }

      let dataIncluir = {
        ...dadosUsuario,
        rowsDisponiveis: dadosUnidades,
        rowsSelecionadas: [],
        operacao: 'INCLUIR',
      }

      setData(dataIncluir);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [formEdit]);

  //Busca dados do usuario para editar o registro
  const handleResponseEditarAPI = useCallback(async () => {
    try {
      setLoading(true);

      //Dados do Usuario
      const { usua_login } = formEdit;
      const response = await api.get(`usuariomaster/${usua_login}`);
      let dadosUsuario = response.data;


      let rowsDisponiveis = {};
      let rowsSelecionadas = {};

      let dataEdicao = {};

      if (dadosUsuario.perf_tipo === GFU) {
        //Busca Unidade geral
        let params = {};
        switch (profile.glousuariotipo) {
          case GFO:
            params = {
              fieldlist: 'unid_nome, unid_codigo ',
              wherefield: ['orga_codigo'],
              typewherefield: ['EQUALS'],
              valuewherefield: [profile.glousuarioorgacodigo],
              orderfield: 'unid_codigo',
              pagesize: 99999,
            }
            break;
          default:
            params = {
              fieldlist: 'unid_nome, unid_codigo, orga_codigo ',
              wherefield: ['orga_codigo'],
              typewherefield: ['EQUALS'],
              valuewherefield: [dadosUsuario.orga_codigo],
              orderfield: 'unid_codigo',
              pagesize: 99999,
            }
        }
        const responseUnidades = await api.get('unidades', {
          params,
          paramsSerializer: (param) => qs.stringify(param),
        });
        let dadosUnidades = responseUnidades.data.items;

        rowsDisponiveis = filterDiffItems(GFO, dadosUnidades, dadosUsuario.unidadeUsuarioVO);
        rowsSelecionadas = filterDiffItems(GFO, dadosUnidades, rowsDisponiveis);

        dataEdicao = {
          ...dadosUsuario,
          dadosPostos: [],
          rowsDisponiveis: rowsDisponiveis,
          rowsSelecionadas: rowsSelecionadas,
          operacao: 'ALTERACAO',
        }

      } else if (dadosUsuario.perf_tipo === GPPEM) {
        //Busca Postos Todos
        let params = {};
        params = {
          fieldlist: 'poco_desc_abrev, poco_codigo',
          orderfield: 'poco_desc_abrev',
          pagesize: 99999,
        }
        const responsePostos = await api.get('postoscomboios', {
          params,
          paramsSerializer: (param) => qs.stringify(param),
        });
        let dadosPostos = responsePostos.data.items;

        rowsDisponiveis = filterDiffItems(GPPEM, dadosPostos, dadosUsuario.usuarioPostoVO);
        rowsSelecionadas = filterDiffItems(GPPEM, dadosPostos, rowsDisponiveis);

        dataEdicao = {
          ...dadosUsuario,
          dadosPostos: dadosPostos,
          rowsDisponiveis: rowsDisponiveis,
          rowsSelecionadas: rowsSelecionadas,
          operacao: 'ALTERACAO',
        }

      } else {
        dataEdicao = {
          ...dadosUsuario,
          dadosPostos: [],
          rowsDisponiveis: [],
          rowsSelecionadas: [],
          operacao: 'ALTERACAO',
        }
      }

      setData(dataEdicao);

      setLoading(false);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [formEdit]);

  const atualizaTabs = useCallback(async (perf_tipo) => {
    setSelectedPerf_tipo(perf_tipo)
    if (profile.glousuariotipo === GFO) {
      setHabTabUnidades(true);
      setHabTabPostos(false);
      return
    }

    if (perf_tipo === 4) {
      setHabTabUnidades(true);
      setHabTabPostos(false);
      return

    } else if (perf_tipo === 8) {
      setHabTabPostos(true);
      setHabTabUnidades(false);

      if (isEmpty(data.dadosPostos)) {
        onHandleBuscaPostosGPPEM(data);
      }

      return
    } else {
      setHabTabUnidades(false);
      setHabTabPostos(false);
    }
  }, [data]);

  useEffect(() => {
    if (!isEmpty(data)) {
      atualizaTabs(data.perf_tipo)
    }
  }, [data]);



  const onHandleAtualizaTabs = useCallback(async () => {
    if (data.perf_tipo === 4) {
      setHabTabUnidades(true);
      setHabTabPostos(false);
      return
    } else if (data.perf_tipo === 8) {
      setHabTabPostos(true);
      setHabTabUnidades(false);
      return
    } else {
      setHabTabUnidades(false);
      setHabTabPostos(false);
    }
  }, [data]);

  const tabs = useMemo(
    () => {
      let array = [];
      let objectValidation1 = {
        usua_login: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .trim()
          .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 20))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          )
          .test(
            'login-invalid',
            "Já existe no banco de dados esse login!",
            function (value) {
              return handleValidateLogin(value);
            }
          ),
        usua_nome: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .trim()
          .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100)),

        usua_cpf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(11, t('s.geral.validacao.tamanhominimo').replace('%s', 11))
          .max(11, t('s.geral.validacao.tamanhomaximo').replace('%s', 11))

          .test(
            'cpf-invalid',
            t('s.configuracao.geral.cpfinvalido'),
            function (value) {
              return validarCPF(value);
            }
          ),

        usua_recebe_email: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),

        usua_email: Yup.string()
          .nullable()
          .when('usua_recebe_email', {
            is: 'S',
            then: Yup.string()
              .nullable()
              .email('Informe um email válido.')
              .required('Informe um email válido.'),
          }),


        usua_senha:
          isEmpty(formEdit) ?
            Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .trim()
              .min(4, t('s.geral.validacao.tamanhominimo').replace('%s', 4))
              .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
              .test(
                'characters-invalid',
                'Somente números são aceitos',
                function (value) {
                  return validSomenteNumeros(value);
                }
              ) :
            Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .trim()
              .min(4, t('s.geral.validacao.tamanhominimo').replace('%s', 4))
              .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
              .test(
                'characters-invalid',
                'Somente números são aceitos',
                function (value) {
                  return validCharactersParaSenha(value) && handleValidateSenha(value);
                }
              ),


        perf_tipo: (profile.glousuariotipo !== GFO) ?
          Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          : Yup.string(),

        perf_codigo: Yup.number().typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1)),

        usua_status: Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1)),

        usua_consulta_controla_agenda: (Number(data.perf_codigo) === Number(GFU_CONSULTA)) ?
          Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
            .min(0, t('s.geral.validacao.campoobrigatorio').replace('%s', 0))
          : Yup.string(),




        // orga_codigo: ((Number(data.perf_tipo) === Number(GFU)) || (Number(data.perf_tipo) === Number(GFO)) ||
        //   (String(data.perf_tipo) === String(GFU)) || (String(data.perf_tipo) === String(GFO))
        // ) ?
        //   Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
        //     .min(2, t('s.geral.validacao.campoobrigatorio').replace('%s', 2))
        //     .nullable()
        //   : Yup.string(),

        // poco_codigo: Yup.string()
        //   .nullable()
        //   .when('perf_tipo', {
        //     is: 6,
        //     then: Yup.string()
        //       .nullable()
        //       .required(t('s.geral.validacao.campoobrigatorio')),
        //   }),


        usua_aprova_pre_faturamento: ((Number(data.perf_tipo) === Number(GFO))
          && (Number(data.perf_codigo) === Number(GFO))) ?
          Yup.string().required(t('s.geral.validacao.usua_aprova_pre_faturamento'))
            .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          : ((Number(data.perf_tipo) === Number(GFE))
            && (Number(data.perf_codigo) === Number(GFE))) ?
            Yup.string().required(t('s.geral.validacao.usua_aprova_pre_faturamento'))
              .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
            : Yup.string()


        // usua_aprova_pre_faturamento: ((Number(data.perf_tipo) === Number(GFO))
        //   && (Number(data.perf_codigo) === Number(GFO))) ?
        //   Yup.string().required(t('s.geral.validacao.usua_aprova_pre_faturamento'))
        //     .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
        //   : Yup.string(),

      }


      if (selectedPerf_tipo == 6) {
        objectValidation1 = merge(objectValidation1, {
          poco_codigo:
            Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
        })
      } else if (selectedPerf_tipo == 3 || selectedPerf_tipo == 4) {
        objectValidation1 = merge(objectValidation1, {
          orga_codigo:
            Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
        })
      }

      let item1 = {

        label: 'Dados',
        component: () => <DadosUsuario
          data={data}
          //onHandleBuscaUnidadeOrgao={onHandleBuscaUnidadeOrgao}
          //onHandleBuscaPostosGPPEM={onHandleBuscaPostosGPPEM}
          onHandleAtualizaTabs={atualizaTabs}
          onHandleAtualizaPerfCodigo={onHandleAtualizaPerfCodigo}

        />,

        validate: objectValidation1
      }

      let item2 = {
        label: 'Unidades',
        component: () => <DadosUnidade data={data}
        //onHandleAddItems={onHandleAddItems}
        //onHandleRemoveItem={onHandleRemoveItem}
        />,
        validate: {},

      }

      let item3 = {
        label: 'Postos',
        component: () => <DadosPosto data={data}
        // onHandleAddItems={onHandleAddItemsPostos}
        // onHandleRemoveItem={onHandleRemoveItemPostos}
        />,
        validate: {},
      }

      array.push(item1);

      if (habTabUnidades) {
        array.push(item2);
      }

      if (habTabPostos) {
        array.push(item3);
      }



      return array

    },
    [data, habTabUnidades, habTabPostos, profile, selectedPerf_tipo]
  );




  // const tabsOK = useMemo(
  //   () => [
  //     {
  //       label: 'Dados',
  //       component: () => <DadosUsuario
  //         data={data}
  //         onHandleBuscaUnidadeOrgao={onHandleBuscaUnidadeOrgao}
  //         onHandleBuscaPostosGPPEM={onHandleBuscaPostosGPPEM}
  //         onHandleAtualizaTabs={atualizaTabs}
  //       />,

  //       validate: {
  //         usua_login: Yup.string()
  //           .required(t('s.geral.validacao.campoobrigatorio'))
  //           .trim()
  //           .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 20))
  //           .test(
  //             'characters-invalid',
  //             t('s.configuracao.geral.naopodecontercaracterespecial'),
  //             function (value) {
  //               return validCharacters(value);
  //             }
  //           ),
  //         usua_nome: Yup.string()
  //           .required(t('s.geral.validacao.campoobrigatorio'))
  //           .trim()
  //           .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100)),

  //         usua_cpf: Yup.string()
  //           .required(t('s.geral.validacao.campoobrigatorio'))
  //           .min(11, t('s.geral.validacao.tamanhominimo').replace('%s', 11))
  //           .max(11, t('s.geral.validacao.tamanhomaximo').replace('%s', 11))

  //           .test(
  //             'cpf-invalid',
  //             t('s.configuracao.geral.cpfinvalido'),
  //             function (value) {
  //               return validarCPF(value);
  //             }
  //           ),

  //         usua_recebe_email: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),

  //         usua_email: Yup.string()
  //           .nullable()
  //           .when('usua_recebe_email', {
  //             is: 'S',
  //             then: Yup.string()
  //               .nullable()
  //               .email('Informe um email válido.')
  //               .required('Informe um email válido.'),
  //           }),


  //         usua_senha: Yup.string()
  //           .required(t('s.geral.validacao.campoobrigatorio'))
  //           .trim()
  //           .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
  //           .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 20))
  //           .test(
  //             'characters-invalid',
  //             t('s.configuracao.geral.naopodecontercaracterespecial'),
  //             function (value) {
  //               return validCharacters(value);
  //             }
  //           ),

  //         perf_tipo: (profile.glousuariotipo !== GFO) ?
  //           Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
  //             .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
  //           : Yup.string(),

  //         perf_codigo: Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
  //           .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1)),

  //         usua_status: Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
  //           .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1)),

  //         usua_consulta_controla_agenda: (Number(data.perf_codigo) === Number(GFU_CONSULTA)) ?
  //           Yup.number().required(t('s.geral.validacao.campoobrigatorio'))
  //             .min(0, t('s.geral.validacao.campoobrigatorio').replace('%s', 0))
  //           : Yup.string(),




  //         orga_codigo: ((Number(data.perf_tipo) === Number(GFU)) || (Number(data.perf_tipo) === Number(GFO)) ||
  //           (String(data.perf_tipo) === String(GFU)) || (String(data.perf_tipo) === String(GFO))
  //         ) ?
  //           Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
  //             .min(2, t('s.geral.validacao.campoobrigatorio').replace('%s', 2))
  //             .nullable()
  //           : Yup.string(),

  //         poco_codigo: Yup.string()
  //           .nullable()
  //           .when('perf_tipo', {
  //             is: 6,
  //             then: Yup.string()
  //               .nullable()
  //               .required(t('s.geral.validacao.campoobrigatorio')),
  //           }),


  //         usua_aprova_pre_faturamento: ((Number(data.perf_tipo) === Number(GFO))
  //           && (Number(data.perf_codigo) === Number(GFO))) ?
  //           Yup.string().required(t('s.geral.validacao.usua_aprova_pre_faturamento'))
  //             .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
  //           : Yup.string(),


  //       },

  //     },
  //     ((habTabUnidades) ?
  //       {
  //         label: 'Unidades',
  //         component: () => <DadosUnidade data={data}
  //           onHandleAddItems={onHandleAddItems}
  //           onHandleRemoveItem={onHandleRemoveItem}
  //         />,
  //         validate: {},
  //       } :
  //       {
  //         label: '',
  //         component: () => <> </>,
  //         validate: {},
  //       }
  //     )
  //     ,
  //     ((habTabPostos) ?
  //       {
  //         label: 'Postos',
  //         component: () => <DadosPosto data={data}
  //           onHandleAddItems={onHandleAddItemsPostos}
  //           onHandleRemoveItem={onHandleRemoveItemPostos}
  //         />,
  //         validate: {},
  //       }
  //       :
  //       {
  //         label: '',
  //         component: () => <> </>,
  //         validate: {},
  //       }

  //     ),
  //   ],
  //   [data, habTabUnidades, habTabPostos]
  // );

  const closeModal = useCallback(() => {
    dispatch(cleanErrors())
    modalRef.current.handleCloseModal();
    onCloseModal();

  }, [onCloseModal]);

  const actions = useMemo(
    () => [
      {
        label: 'Confirmar',
        callback: () => tabRef.current.onValidate(),
        color: 'primary',
        variant: 'outlined',
      },
      {
        label: 'Cancelar',
        callback: () => closeModal(),
        color: 'secondary',
        variant: 'outlined',
      },
    ],
    [data]
  );

  const handleValidateSenha = useCallback((value) => {
    if (!isEmpty(formEdit)) {
      if (formEdit.usua_senha !== value) {
        if (!validSomenteNumeros(value)) {
          return false;
        }
      }
    }
    return true
  }, [formEdit])

  const handleValidateLogin = useCallback(async (value) => {
    if (isEmpty(formEdit)) {

      const login = get(data, 'usua_login', '');
      const response = await api.get(`usuariomaster/${login}`);
      let dadosUsuario = response.data;
      if (!isEmpty(dadosUsuario.usua_login)) {
        return false;
      }

    }
    return true
  }, [formEdit, data, params])







  const filterDiffItems = React.useCallback((perf_tipo, arrayBase, arraySelecionado) => {
    let listaDist = arrayBase || [];
    let onlyInA = [];
    let onlyInB = [];
    if (String(perf_tipo) === '8') {
      onlyInA = listaDist.filter(comparerPosto(arraySelecionado));
      onlyInB = arraySelecionado.filter(comparerPosto(listaDist));
    } else {
      onlyInA = listaDist.filter(comparerUnidade(arraySelecionado));
      onlyInB = arraySelecionado.filter(comparerUnidade(listaDist));
    }
    let result = onlyInA.concat(onlyInB);
    return result;
  }, []);

  const comparerPosto = React.useCallback((otherArray) => {
    return function (current) {
      return otherArray.filter(function (other) {
        return other.poco_codigo == current.poco_codigo
      }).length == 0;
    }
  }, []);

  const comparerUnidade = React.useCallback((otherArray) => {
    return function (current) {
      return otherArray.filter(function (other) {
        return other.unid_codigo == current.unid_codigo
      }).length == 0;
    }
  }, []);

  const strReverse = React.useCallback((s) => {
    let o = [];
    for (let i = 0, len = s.length; i <= len; i++)
      o.push(s.charAt(len - i));
    return o.join('');
  }, []);

  // function reverse(s) {
  //   var o = [];
  //   for (var i = 0, len = s.length; i <= len; i++)
  //     o.push(s.charAt(len - i));
  //   return o.join('');
  // }


  const handleValidation = useCallback(async (values) => {

    try {
      if (values.perf_tipo == 6) {
        const schemaGpp = Yup.object().shape({
          poco_codigo: Yup.string(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
        });
        await schemaGpp.validate(values, {
          abortEarly: false,
        });
      } else if (values.perf_tipo == 3) {
        const schemaGfo = Yup.object().shape({
          orga_codigo: Yup.string(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
        });
        await schemaGfo.validate(values, {
          abortEarly: false,
        });
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        formRef.current.setErrors(validationErrors);
      }
    }

  }, [formRef])


  const handleSubmit = React.useCallback(
    async (values) => {
      setLoading(true)
      setSubmittingLoading(true)

      const dados = { ...data, ...values };


      if ((Number(dados.perf_tipo) === GFO) || (Number(dados.perf_tipo) === GFU)) {
        if (dados.orga_codigo) {
          const orgao = String(dados.orga_codigo);

          if (orgao.length <= 2) {
            //tabRef.current.setFieldError("orga_codigo", "O nome é obrigatório");
            toast.error('É necessário selecionar um órgao!');
            setLoading(false)
            setSubmittingLoading(false)
            return;
          }

        } else {
          //tabRef.current.setFieldError("orga_codigo", "O nome é obrigatório");
          toast.error('É necessário selecionar um órgao!');
          setLoading(false)
          setSubmittingLoading(false)
          return;
        }
      }

      if (isEmpty(formEdit)) {
        const login = get(dados, 'usua_login', '');
        const response = await api.get(`usuariomaster/${login}`);
        let dadosUsuario = response.data;
        if (!isEmpty(dadosUsuario.usua_login)) {
          toast.error('O login já está cadastrado!');
          setLoading(false)
          setSubmittingLoading(false)
          return;
        }
      }



      // if (!isEmpty(formEdit)) {
      //   if (formEdit.usua_senha !== dados.usua_senha) {
      //     if (!validSomenteNumeros(dados.usua_senha)) {
      //       toast.error('Sómente números são aceitos no campo senha!');
      //       setLoading(false)
      //       setSubmittingLoading(false)
      //       return;
      //     }
      //   }
      // }

      let lSenha = dados.usua_senha;
      let sNumerics = '01234567890';

      /* Senha nao pode comecar com zero */
      if (lSenha.substr(0, 1) === "0") {
        toast.error('A senha não pode começar com 0 (zero).');
        setLoading(false)
        setSubmittingLoading(false)

        //this.lAlert = Alert.show("A senha não pode começar com 0 (zero).","Erro 1! Senha!", Alert.OK,null,null,Application.application.iconExclamacao);
        //this.lAlert.styleName = "AlertStyle";
        return;
      }

      /* Verifica sequencia numerica (normal e inverso) */
      for (let i = 0; i <= 7; i++) {
        let sFwd = sNumerics.substring(i, i + 4);
        let sRev = strReverse(sFwd); //sFwd => [...sFwd].reverse().join(''); //  :String = this.strReverse(sFwd);
        if (lSenha.indexOf(sFwd) !== -1 || lSenha.indexOf(sRev) != -1) {
          toast.error('A senha não pode ser sequencial.');
          setLoading(false)
          setSubmittingLoading(false)
          //this.lAlert = Alert.show("A senha não pode ser sequencial.","Erro 2! Senha!", Alert.OK,null,null,Application.application.iconExclamacao);
          //this.lAlert.styleName = "AlertStyle";
          return;
        }
      }


      /* Verifica repeticao numerica */
      for (let i = 0; i <= 9; i++) {

        let verAux = i.toString() + i.toString() + i.toString() + i.toString();
        let verLSenhaAux = lSenha.substr(0, 4);

        //if (lSenha === (i.toString() + i.toString() + i.toString() + i.toString()).toString()) {
        if (verLSenhaAux === verAux) {
          toast.error('A senha não pode ser números repetidos');
          setLoading(false)
          setSubmittingLoading(false)
          //this.lAlert = Alert.show("A senha não pode ser números repetidos.", "Erro 3! Senha!", Alert.OK, null, null, Application.application.iconExclamacao);
          //this.lAlert.styleName = "AlertStyle";
          return;
        }
      }




      const usuarioMasterVOL = { ...usuarioMasterVO };
      usuarioMasterVOL.usua_login = get(dados, 'usua_login', '');
      usuarioMasterVOL.perf_codigo = get(dados, 'perf_codigo', 0);
      usuarioMasterVOL.orga_codigo = get(dados, 'orga_codigo',
        (profile.glousuariotipo === GFO) ?
          profile.glousuarioorgacodigo
          : 0);
      usuarioMasterVOL.usua_nome = get(dados, 'usua_nome', '');
      usuarioMasterVOL.usua_tipo = get(dados, 'usua_tipo', 'U');
      usuarioMasterVOL.usua_senha = get(dados, 'usua_senha', '');
      usuarioMasterVOL.usua_parametro1 = get(dados, 'usua_parametro1', '');
      usuarioMasterVOL.usua_parametro2 = get(dados, 'usua_parametro2', '');
      usuarioMasterVOL.usua_parametro3 = get(dados, 'usua_parametro3', '');
      usuarioMasterVOL.usua_parametro4 = get(dados, 'usua_parametro4', '');
      usuarioMasterVOL.usua_parametro5 = get(dados, 'usua_parametro5', '');
      usuarioMasterVOL.usua_parametro6 = get(dados, 'usua_parametro6', '');
      usuarioMasterVOL.usua_parametro7 = get(dados, 'usua_parametro7', '');
      usuarioMasterVOL.usua_parametro8 = get(dados, 'usua_parametro8', '');
      usuarioMasterVOL.usua_status = get(dados, 'usua_status', 0);
      usuarioMasterVOL.usua_cont_senha_errada = get(dados, 'usua_cont_senha_errada', 0);

      if (Number(dados.perf_tipo) === GPP) {
        usuarioMasterVOL.poco_codigo = get(dados, 'poco_codigo', '');
      } else {
        usuarioMasterVOL.poco_codigo = '';
      }

      usuarioMasterVOL.usua_email = get(dados, 'usua_email', '');
      usuarioMasterVOL.usua_recebe_email = get(dados, 'usua_recebe_email', 'N');
      usuarioMasterVOL.orga_codigo_aux = get(dados, 'orga_codigo_aux', 0);
      usuarioMasterVOL.usua_cpf = get(dados, 'usua_cpf', '');

      if (Number(dados.perf_tipo) === GFU) {
        usuarioMasterVOL.usua_consulta_controla_agenda = get(dados, 'usua_consulta_controla_agenda', 0);
      } else {
        usuarioMasterVOL.usua_consulta_controla_agenda = 0;
      }

      if ((Number(dados.perf_tipo) === GFO) || (Number(dados.perf_tipo) === GFE)) {
        usuarioMasterVOL.usua_aprova_pre_faturamento = get(dados, 'usua_aprova_pre_faturamento', 'N');
      } else {
        usuarioMasterVOL.usua_aprova_pre_faturamento = 'N';
      }
      // if (Number(dados.perf_tipo) === GFO) {
      //   usuarioMasterVOL.usua_aprova_pre_faturamento = get(dados, 'usua_aprova_pre_faturamento', 'N');
      // } else {
      //   usuarioMasterVOL.usua_aprova_pre_faturamento = 'N';
      // }

      usuarioMasterVOL.fadi_codigo = get(dados, 'fadi_codigo', 0);

      usuarioMasterVOL.perf_tipo = get(dados, 'perf_tipo', 0);

      let listaSelecionadas = dados.rowsSelecionadas;
      let ListaRowsPostos = [];
      let ListaRowsUnidades = [];
      if (listaSelecionadas) {
        if (String(usuarioMasterVOL.perf_tipo) === '8') {
          for (let i = 0; i < listaSelecionadas.length; i++) {
            const usua_login = usuarioMasterVOL.usua_login;
            const poco_codigo = listaSelecionadas[i].poco_codigo;
            const obj = createDataPercPosto(usua_login, poco_codigo);
            ListaRowsPostos.push(obj);
          }
        }
        if (String(usuarioMasterVOL.perf_tipo) === '4') {
          for (let i = 0; i < listaSelecionadas.length; i++) {
            const usua_login = usuarioMasterVOL.usua_login;
            const unid_codigo = listaSelecionadas[i].unid_codigo;
            const orga_codigo = usuarioMasterVOL.orga_codigo;

            const obj = createDataPercUnidade(orga_codigo, unid_codigo, usua_login);
            ListaRowsUnidades.push(obj);
          }
        }
      }
      usuarioMasterVOL.usuarioPostoVO = ListaRowsPostos;
      usuarioMasterVOL.unidadeUsuarioVO = ListaRowsUnidades;

      try {
        if (isEmpty(formEdit)) {
          await dispatch(storeCadastroUsuarioMaster(usuarioMasterVOL, params));
        } else {
          await dispatch(updateCadastroUsuarioMaster(usuarioMasterVOL, params));
        }
        setOnSubmitting(true)
      } catch (err) {
        toast.error(err);
      }
    },
    [data, params]
  );


  function createDataPercPosto(usua_login, poco_codigo) {
    return { usua_login, poco_codigo };
  }

  function createDataPercUnidade(orga_codigo, unid_codigo, usua_login) {
    return { orga_codigo, unid_codigo, usua_login };
  }


  // const onHandleAddItems = useCallback((arrayData) => {
  //   const objSend = {
  //     ...data,
  //     rowsDisponiveis: differenceBy(data.rowsDisponiveis, arrayData, 'unid_codigo'),
  //     rowsSelecionadas: concat(data.rowsSelecionadas, arrayData),
  //   };
  //   setData(objSend);
  // }, [data]);

  // const onHandleRemoveItem = useCallback((arrayData) => {
  //   const objSend = {
  //     ...data,
  //     rowsDisponiveis: concat(data.rowsDisponiveis, arrayData),
  //     rowsSelecionadas: differenceBy(data.rowsSelecionadas, arrayData, 'unid_codigo'),
  //   };
  //   setData(objSend);
  // }, [data]);

  // const onHandleAddItemsPostos = useCallback((arrayData) => {
  //   const objSend = {
  //     ...data,
  //     rowsDisponiveis: differenceBy(data.rowsDisponiveis, arrayData, 'poco_codigo'),
  //     rowsSelecionadas: concat(data.rowsSelecionadas, arrayData),
  //   };
  //   setData(objSend);
  // }, [data]);

  // const onHandleRemoveItemPostos = useCallback((arrayData) => {
  //   const objSend = {
  //     ...data,
  //     rowsDisponiveis: concat(data.rowsDisponiveis, arrayData),
  //     rowsSelecionadas: differenceBy(data.rowsSelecionadas, arrayData, 'poco_codigo'),
  //   };
  //   setData(objSend);
  // }, [data]);


  return (
    <>
      <Modal
        ref={modalRef}
        title={'Cadastro de Usuários'}
        disableBackdropClick
        disableEscapeKeyDown

        //noPadding
        component={() => (
          <>
            {submittingLoading ?

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ display: 'flex', flexFlow: 'column', alignItems: 'center' }}>
                  <CircularProgress
                    size={30}
                    color="primary"
                  // style={{ margin: '10px' }}
                  />
                  <Typography variant="h6">Salvando Alterações...</Typography>
                </div>

              </div>
              :
              <>
                <Spinner loading={loading} />

                <Tabs
                  ref={tabRef}
                  //color="default"
                  color="white"
                  indicatorColor="primary"
                  textColor="primary"
                  tabs={tabs}
                  getData={(value) => handleSubmit(value)}
                  initials={data}
                />
              </>}

          </>
        )}
        actions={submittingLoading ? [] : actions}
      />
    </>

  );
});

Form.propTypes = {
  formEdit: PropTypes.objectOf(PropTypes.any),
  onCloseModal: PropTypes.func.isRequired,
};

Form.defaultProps = {
  formEdit: {},
};

export default Form;
